import { render, staticRenderFns } from "./ChangeInscriptionCard.vue?vue&type=template&id=151a14e0&scoped=true"
import script from "./ChangeInscriptionCard.vue?vue&type=script&lang=js"
export * from "./ChangeInscriptionCard.vue?vue&type=script&lang=js"
import style0 from "./ChangeInscriptionCard.vue?vue&type=style&index=0&id=151a14e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a14e0",
  null
  
)

export default component.exports